import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Entity } from '@debbie/common/dist/index.js';
import { InteractionType, Direction } from '@debbie/common/dist/interactions/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { Inbox, Phone } from '../Icons/index.js';
import FileIcon from '../Icons/File.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import CallInteraction from './CallInteraction.js';
import EmailInteraction from './EmailInteraction.js';
import NoteInteraction from './NoteInteraction.js';
import RecipientContent from './RecipientContent.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
const CreditorContactPerson = (props) => {
    const tenant = useSelector(selectTenant);
    const users = useSelector((s) => s.users);
    const creditorLoadable = useCreditor(props.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const userRes = creditor && creditor.contactId && users[creditor.contactId];
    const user = userRes && h.isLoaded(userRes) ? userRes.data : null;
    const collectorLoadable = useCollector(tenant?.collectorIdentityId);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    useEffect(() => {
        if (!user && creditor && creditor.contactId) {
            c.users.getById(creditor.contactId);
        }
    }, [creditor]);
    const emailTo = user && user.email;
    if (!(creditor && collector))
        return (React.createElement("div", null,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(PlaceholderLoader, { width: "80%" }),
            React.createElement(PlaceholderLoader, { width: "35%" }),
            React.createElement(PlaceholderLoader, { width: "66%" })));
    const tabs = [
        {
            children: (React.createElement(EmailInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor, isDebtor: true, emailTo: emailTo })),
            icon: Inbox,
            label: lang.interactionTypes.EMAIL,
            shouldHide: !emailTo || !emailServer,
        },
        {
            children: (React.createElement(CallInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor })),
            icon: Phone,
            label: lang.interactionTypes.PHONE,
        },
        {
            children: (React.createElement(NoteInteraction, { referenceId: props.creditorId, referenceType: Entity.Creditor, options: {
                    direction: Direction.OUTGOING,
                    type: InteractionType.Note,
                }, sendButtonText: lang.interactions.addNote })),
            icon: FileIcon,
            label: lang.interactionTypes.NOTE,
        },
    ];
    return React.createElement(RecipientContent, { tabs: tabs });
};
export default CreditorContactPerson;
//# sourceMappingURL=CreditorContactPerson.js.map